import i18n from '../../i18n'

export default class ErrorHelper{
  constructor(res, error) {
    this.res = res
    this.error = error
  }

  setError(){
    if ( this.res.body == null || this.res.body.errors == null) {
      this.error.save = i18n.t('validation:general_error')
    }else{
      for ( let e of Object.keys(this.res.body.errors) ) {
        if ( Array.isArray(this.res.body.errors[e]) ){
          if ( typeof this.res.body.errors[e][0] == 'object' ){
            this.error[e] = {}
            this.res.body.errors[e].forEach( v => {
              this.error[e] = Object.assign({}, this.error[e], v)
            })
          }else{
            // Some forms still don't handle array
            this.error[e] = this.res.body.errors[e][0]
          }
        }else{
          this.error[e] = this.res.body.errors[e]
        }
      }
    }
    return this.error
  }

  isExistError(){
    for ( let e of Object.keys(this.error) ) {
      if ( this.error[e].length > 0 && e != 'save' ) {
        return true
      }
    }
    return false
  }

  clearError(params){
    for ( let e of Object.keys(params) ) {
      this.error[e] = ""
    }
    return this.error
  }

  clearAllError(){
    for ( let e of Object.keys(this.error) ) {
      this.error[e] = ""
    }
    return this.error
  }

  updateError(params){
    return Object.assign({}, this.error, params)
  }

  multiLanguageError(lang){
    if ( typeof this.error === 'object' ) {
      return this.error[lang] || ''
    }else{
      try {
        return JSON.parse(this.error)[lang]
      }catch(e){
        return this.error
      }
    }
  }
}
